/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

export type ImageUploadInContentType = typeof ImageUploadInContentType[keyof typeof ImageUploadInContentType];


export const ImageUploadInContentType = {
  'image/jpeg': 'image/jpeg',
  'image/png': 'image/png',
  'image/webp': 'image/webp',
  'image/gif': 'image/gif',
  'image/avif': 'image/avif',
  'image/bmp': 'image/bmp',
  'image/heic': 'image/heic',
} as const;
